import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Table, Button, Spinner, Modal, Dropdown } from 'react-bootstrap';
import classNames from 'classnames';
import Flex from '../../common/Flex';
import Avatar from '../../common/Avatar';
import { list, remove } from '../../../lib/api/staff';
import { Add } from './Add';
import { Edit } from './Edit';
import { List as EditContact } from '../contact/Lista';
import CardDropdown from 'components/common/CardDropdown';

export const List = () => {
  const [staff, setStaff] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [selectedStaff, setSelectedStaff] = useState(null);

  const user = JSON.parse(localStorage.getItem('user'));

  const handleNew = () => {
    setSelectedStaff(null);
    setShowModal(true);
  };

  const handleEdit = id => {
    const currentStaff = staff.find(c => c.document_guid === id);
    setSelectedStaff(currentStaff);
    setShowModal(true);
  };

  const handleContact = id => {
    const currentStaff = staff.find(c => c.document_guid === id);
    setSelectedStaff(currentStaff);
    setShowContactModal(true);
  };

  const handelDelete = async id => {
    setIsLoading(true);
    try {
      if (confirm('Da li ste sigurni da zelite da izbrisete osoblje?')) {
        await remove(id);
        setStaff(staff.filter(item => item.document_guid !== id));
      }
    } catch (error) {
      console.error('Failed to delete item', error);
    } finally {
      setIsLoading(false);
    }
  };

  const getStaff = () => {
    setIsLoading(true);
    list()
      .then(res => setStaff(res))
      .catch(err => console.error(err))
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    getStaff();
  }, []);

  const getStaffName = item => `${item.name} ${item.last_name}`;

  const renderActions = item => (
    <CardDropdown>
      <div className="py-2">
        <Dropdown.Item onClick={() => handleContact(item.document_guid)}>Kontakti</Dropdown.Item>
        <Dropdown.Item onClick={() => handleEdit(item.document_guid)}>Izmjeni</Dropdown.Item>
        <Dropdown.Item className="text-danger" onClick={() => handelDelete(item.document_guid)}>
          Delete
        </Dropdown.Item>
      </div>
    </CardDropdown>
  );

  return (
    <Card className={classNames('h-100')}>
      <Card.Header>
        <Row className={classNames('g-2')}>
          <Col>
            <Flex>
              <h5 className="mb-0 hover-actions-trigger text-truncate text-nowrap">
                Spisak ostalog osoblja
              </h5>
            </Flex>
          </Col>
          <Col xs="auto">
            {!user.club_guid ? (
              <Button onClick={handleNew} variant="primary">
                Dodaj osoblje
              </Button>
            ) : (
              ''
            )}
          </Col>
        </Row>
      </Card.Header>
      <Card.Body className="bg-body-tertiary">
        {isLoading ? (
          <div className="text-center">
            <Spinner animation="border" role="status" />
          </div>
        ) : (
          <Row className="mb-3">
            <div className="d-none d-xl-block">
              <Table responsive className="mb-0">
                <thead>
                  <tr>
                    <th scope="col">Ime i prezime</th>
                    <th scope="col">Vrsta</th>
                    <th className="text-end" scope="col">
                      Akcija
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {staff.map((item, i) => (
                    <tr key={i}>
                      <td className="text-nowrap">
                        <div className="d-flex align-items-center">
                          <Avatar
                            src={`${process.env.REACT_APP_BASE_API_URL}/uploads/${item.image_path}`}
                            size="2xl"
                            name={item.name}
                          />
                          <div className="ms-2">{getStaffName(item)}</div>
                        </div>
                      </td>
                      <td>
                        <div className="ms-2">{item.staff_type_name}</div>
                      </td>
                      <td className="text-end">{renderActions(item)}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>

            <div className="d-xl-none">
              <Row className="g-3">
                {staff.map(item => (
                  <Col xs={12} key={item.document_guid}>
                    <div
                      className="border rounded-4 bg-white h-100 p-3 shadow-sm"
                      style={{ borderColor: '#dfe3ee' }}
                    >
                      <div className="d-flex align-items-start justify-content-between gap-3">
                        <div className="flex-shrink-0">
                          <Avatar
                            src={`${process.env.REACT_APP_BASE_API_URL}/uploads/${item.image_path}`}
                            size="2xl"
                            name={item.name}
                          />
                        </div>
                        <div className="flex-shrink-0">{renderActions(item)}</div>
                      </div>

                      <div className="mt-3">
                        <div className="fw-semibold text-dark fs-8">
                          {getStaffName(item)}
                        </div>

                        <div className="d-flex flex-wrap gap-2 mt-2">
                          <span className="badge rounded-pill badge-subtle-success">
                            {item.staff_type_name || '-'}
                          </span>
                        </div>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </Row>
        )}
      </Card.Body>

      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            {selectedStaff ? 'Izmijeni ostalog osoblja' : 'Dodaj ostalo osoblja'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedStaff ? (
            <Edit
              initialData={selectedStaff}
              onClose={() => setShowModal(false)}
              onSave={getStaff}
            />
          ) : (
            <Add onClose={() => setShowModal(false)} onSave={getStaff} />
          )}
        </Modal.Body>
      </Modal>

      <Modal show={showContactModal} onHide={() => setShowContactModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Kontakt</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditContact initPartner={selectedStaff} onClose={() => setShowContactModal(false)} />
        </Modal.Body>
      </Modal>
    </Card>
  );
};

export default List;
